import React, { Component } from "react";
import gql from "graphql-tag";
import { Mutation } from "react-apollo";

import { CommandBarButton, ActionButton } from "office-ui-fabric-react/lib/Button";
import { ContextualMenuItemType } from "office-ui-fabric-react/lib/ContextualMenu";

class OrderTagButton extends Component {
  render() {
    const { items } = this.props;
    return (
      <div>
        <Mutation mutation={UPDATE_ORDER_TAG}>
          {(mutate, { data }) => (
            <ActionButton
              // styles={{ root: { padding: "10px" } }}
              iconProps={{ iconName: "Tag" }}
              title="Add tag to order"
              menuProps={{
                shouldFocusOnMount: true,
                items: [
                  {
                    key: "loaded",
                    name: "Tag as loaded",
                    onClick: () => {
                      items.map((item, key) => {
                        const tags = JSON.parse(item.tags);
                        mutate({
                          variables: {
                            id: item.id,
                            tags: JSON.stringify({
                              ...tags,
                              loaded: true
                            })
                          }
                        });
                      });
                    },
                    iconProps: {
                      iconName: "Tag",
                      color: "green"
                    }
                  },
                  {
                    key: "divider_1",
                    itemType: ContextualMenuItemType.Divider
                  },
                  {
                    key: "remove",
                    name: "Remove tag",
                    onClick: () => {
                      items.map((item, key) => {
                        const tags = JSON.parse(item.tags);
                        mutate({
                          variables: {
                            id: item.id,
                            tags: JSON.stringify({
                              ...tags,
                              loaded: ''
                            })
                          }
                        });
                      });
                    },
                  }
                ]
              }}
            />
          )}
        </Mutation>
      </div>
    );
  }
}

const UPDATE_ORDER_TAG = gql`
  mutation($id: Int!, $tags: JSON) {
    updateOrderById(input: { id: $id, orderPatch: { tags: $tags } }) {
      order {
        id
        tags
      }
    }
  }
`;

export default OrderTagButton;



// WEBPACK FOOTER //
// ./src/common/Buttons/_OrderTagButton.js